import React from 'react'

const NextTrack = props => (
  <svg width="10px" height="12px" viewBox="0 0 10 12" style={{ flexShrink: 0 }} {...props}>
    <polygon fill="#FAFBFB" points="8,0 8,4.8 0,0 0,12 8,7.2 8,12 10,12 10,0" />
  </svg>
)

export default NextTrack
